import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { fetchConToken } from 'helpers/fetch';
import { alertService } from '_services';
import Swal from 'sweetalert2';
import { useUIUtils } from 'hooks/useUIUtils';
import { avisarError, BotonesForma, Campo, cargar, sucursalActual, SwitchSN, Tarjeta } from '../comun';

const AddEdit = ({ history, match }) => {
    const { id } = match.params;
    const isAddMode = !id;
    const { handleSubmit } = useForm();
    const { changeGlobalTitle } = useUIUtils();
    const [almacenes, setAlmacenes] = useState([]);
    const [formas, setFormas] = useState([]);
    const [folios, setFolios] = useState([]);
    const [estatus, setEstatus] = useState(null);
    const [folio, setFolio] = useState({ tipo_Docto: 'V', serie: 'V', consecutivo: 1 });
    const [model, setModel] = useState({
        nombre: '',
        sucursal_Id: sucursalActual(),
        almacen_Id: '',
        modificar_Almacen: 'S',
        permite_Cobrar: 'S',
        forma_Cobro_Predet_Id: '',
        estutus: 'A'
    });

    const recargarFolios = () => {
        if (!id) return;

        cargar(`pv/PvCajas/Folios?caja_id=${id}`).then(setFolios);
        fetchConToken(`pv/PvCajas/Estatus?caja_id=${id}`).then((response) => { if (!avisarError(response)) setEstatus(response); });
    }

    useEffect(() => {
        changeGlobalTitle(isAddMode ? 'Agregar caja' : 'Editar caja');
        cargar(`Almacenes/GetList?paginas=0&totalXpagina=200&sucursal_Id=${sucursalActual()}&busqueda=`).then(setAlmacenes);
        cargar('pv/PvFormasCobros/GetList?paginas=0&totalXpagina=200&busqueda=').then(setFormas);
        if (!isAddMode) {
            fetchConToken(`pv/PvCajas?id=${id}`).then((response) => { if (!avisarError(response)) setModel(response); });
            recargarFolios();
        }

    }, [changeGlobalTitle, id, isAddMode]);

    function onSubmit() {
        const data = {
            ...model,
            sucursal_Id: Number(sucursalActual()),
            almacen_Id: Number(model.almacen_Id),
            forma_Cobro_Predet_Id: model.forma_Cobro_Predet_Id ? Number(model.forma_Cobro_Predet_Id) : null
        };
        return fetchConToken('pv/PvCajas', data, isAddMode ? 'POST' : 'PUT').then((response) => {
            if (avisarError(response)) return false;

            Swal.fire('Exito', 'Guardado', 'success');
            history.push(isAddMode ? '.' : '..');
        })
            .catch(alertService.error);
    }

    function crearFolio(event) {
        event.preventDefault();
        fetchConToken('pv/PvCajas/Folios', {
            caja_Id: Number(id),
            tipo_Docto: folio.tipo_Docto,
            serie: folio.serie,
            consecutivo: Number(folio.consecutivo)
        }, 'POST').then((response) => {
            if (avisarError(response)) return;

            Swal.fire('Exito', 'Folio creado', 'success');
            recargarFolios();
        }).catch(alertService.error);
    }

    const handleInputChange = ({ target }) => setModel({ ...model, [target.name]: target.value });
    const onChangeCheck = ({ target }) => setModel({ ...model, [target.name]: target.checked ? 'S' : 'N' });

    return (<div className='container-fluid'>
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className='mb-3'><div className='row'><BotonesForma isAddMode={isAddMode} /></div></div>
            <div className='row'>
                <div className='col-md-6'>
                    <Tarjeta titulo='Caja'>
                        <Campo label='Nombre'>
                            <input className='form-control' name='nombre' required value={model.nombre || ''} onChange={handleInputChange} />
                        </Campo>
                        <Campo label='Almacen'>
                            <select className='form-select' name='almacen_Id' required value={model.almacen_Id || ''} onChange={handleInputChange}>
                                <option value=''>Seleccione</option>
                                {almacenes.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                            </select>
                        </Campo>
                        <Campo label='Forma de cobro predeterminada'>
                            <select className='form-select' name='forma_Cobro_Predet_Id' value={model.forma_Cobro_Predet_Id || ''} onChange={handleInputChange}>
                                <option value=''>Sin predeterminada</option>
                                {formas.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                            </select>
                        </Campo>
                        <Campo label='Estatus'>
                            <select className='form-select' name='estutus' value={model.estutus || 'A'} onChange={handleInputChange}>
                                <option value='A'>Activo</option>
                                <option value='I'>Inactivo</option>
                            </select>
                        </Campo>
                        <SwitchSN name='modificar_Almacen' label='Permite cambiar el almacen' checked={model.modificar_Almacen} onChange={onChangeCheck} />
                        <div className='espacio15px' />
                        <SwitchSN name='permite_Cobrar' label='Permite cobrar' checked={model.permite_Cobrar} onChange={onChangeCheck} />
                        {estatus && <p className='mt-3 mb-0'>Estatus actual: {estatus.estatus_Descrip || (estatus.abierta ? 'Abierta' : 'Cerrada')}</p>}
                    </Tarjeta>
                </div>
                {!isAddMode && (<div className='col-md-6'>
                    <Tarjeta titulo='Folios'>
                        <table className='table table-sm'>
                            <thead><tr><th>Tipo</th><th>Serie</th><th>Consecutivo</th></tr></thead>
                            <tbody>
                                {folios.map((item) => (<tr key={item.id}><td>{item.tipo_Docto}</td><td>{item.serie}</td><td>{item.consecutivo}</td></tr>))}
                            </tbody>
                        </table>
                        <div className='row'>
                            <div className='col-md-4'>
                                <Campo label='Tipo'>
                                    <select className='form-select' value={folio.tipo_Docto} onChange={({ target }) => setFolio({ ...folio, tipo_Docto: target.value })}>
                                        <option value='O'>Orden</option>
                                        <option value='V'>Venta</option>
                                        <option value='D'>Devolucion</option>
                                        <option value='P'>Cobro CxC</option>
                                        <option value='I'>Ingreso</option>
                                        <option value='R'>Retiro</option>
                                    </select>
                                </Campo>
                            </div>
                            <div className='col-md-4'>
                                <Campo label='Serie'>
                                    <input className='form-control' value={folio.serie} onChange={({ target }) => setFolio({ ...folio, serie: target.value })} />
                                </Campo>
                            </div>
                            <div className='col-md-4'>
                                <Campo label='Consecutivo'>
                                    <input type='number' className='form-control' value={folio.consecutivo} onChange={({ target }) => setFolio({ ...folio, consecutivo: target.value })} />
                                </Campo>
                            </div>
                        </div>
                        <button type='button' className='btn btn-outline-primary' onClick={crearFolio}>Crear folio</button>
                    </Tarjeta>
                </div>)}
            </div>
        </form>
    </div>);
};

export { AddEdit };
